var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speakout-container{width:100vw;height:100vh;position:relative;background-image:url(" + escape(require("./poster.jpg")) + ");background-size:cover;background-repeat:no-repeat}@keyframes postermove{0%{opacity:.2}to{opacity:1}}.speakout-button-container{margin:auto;width:100%;animation:postermove 2s ease-in 1}.speakout-title{font-family:PingFangSC-Semibold;font-size:20px;padding-top:80px}.speakout-main,.speakout-title{color:#fff;line-height:28px;animation:postermove 2s ease-in 1}.speakout-main{padding:14.4%;font-family:PingFangSC-Regular;font-size:14px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/layouts/PageLayout/Poster/SpeakOut.css
// module id = 344
// module chunks = 5